import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const userData = sessionStorage.getItem('userData');
  if (!userData) {
    sessionStorage.setItem('unauthorizedRedirect', 'true'); // Set a flag
    return <Navigate to="/" />;
  }
  return children;
};

export default PrivateRoute;
